"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiCartsClient = void 0;
const ApiSubClient_1 = require("../../common/client/ApiSubClient");
const expandUrlTemplate_1 = __importDefault(require("../../common/utils/expandUrlTemplate"));
const CartConverter_1 = require("../CartConverter");
class ApiCartsClient extends ApiSubClient_1.ApiSubClient {
    async getCart() {
        const cartsLink = this.getLinkOrThrow('cart');
        return this.axios
            .get((0, expandUrlTemplate_1.default)(cartsLink.href, {}))
            .then((it) => CartConverter_1.CartConverter.convertCart(it.data));
    }
    async addItemToCart(cart, videoId) {
        const orderLink = cart.links.addItem.getOriginalLink();
        return this.axios
            .post(orderLink, { videoId }, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            },
        })
            .then((it) => CartConverter_1.CartConverter.convertCartItem(it.data));
    }
    async updateCart(note) {
        const cartsLink = this.getLinkOrThrow('cart');
        return this.axios
            .patch(cartsLink.href, { note }, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            },
        })
            .then((it) => CartConverter_1.CartConverter.convertCart(it.data));
    }
    async updateCartItemAdditionalServices(cartItem, additionalServices) {
        const updateLink = cartItem.links.additionalServices.getOriginalLink();
        return this.axios
            .patch(updateLink, additionalServices, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            },
        })
            .then((it) => CartConverter_1.CartConverter.convertCart(it.data));
    }
    async deleteItemFromCart(cart, cartItemId) {
        const orderLink = cart.items
            .find((it) => it.id === cartItemId)
            .links.self.getOriginalLink();
        return this.axios.delete(orderLink);
    }
}
exports.ApiCartsClient = ApiCartsClient;
//# sourceMappingURL=ApiCartsClient.js.map